<template>
  <div class="columns is-marginless is-paddingless section section-details">
    <div class="mgt-20px column is-10">
      <div class="card" id="caracteristiques">
        <header class="header-card">
          <p>
            {{ $t('detailDispositif.infoGeneral.title.caracteristiques') }}
          </p>
        </header>
        <div class="card-content columns">
          <div class="column is-2">
            <app-logo readOnly
                      :elementId="dispositifPublicitaire.id"
                      :libelleElement="$t('detailDispositif.libelleForLogo',
                      { code: dispositifPublicitaire.code })"></app-logo>
          </div>
          <div class="columns is-multiline mgt-10px">
            <div class="column is-3">
              <b-field :label="$t('detailDispositif.infoGeneral.code')"
                      custom-class="has-text-link">
                <p class="has-text-default">{{ dispositifPublicitaire.code }}</p>
              </b-field>
            </div>
            <div class="column is-3" v-if="moduleEmplacementClientActive">
              <b-field :label="$t('detailDispositif.infoGeneral.nom')"
                      custom-class="has-text-link">
                <p class="has-text-default">{{ dispositifPublicitaire.nom }}</p>
              </b-field>
            </div>
            <div class="column is-3">
              <b-field :label="$t('detailDispositif.infoGeneral.support')"
                      custom-class="has-text-link">
                <p class="has-text-default">{{ dispositifPublicitaire.dispositifSupport === null
                  ? '' : dispositifPublicitaire.dispositifSupport.libelle}}</p>
              </b-field>
            </div>
            <div class="column is-3">
              <b-field :label="$t('detailDispositif.infoGeneral.typeDispositif')"
                      custom-class="has-text-link">
                <p class="has-text-default">{{ dispositifPublicitaire.dispositifType === null ? ''
                  : dispositifPublicitaire.dispositifType.libelle }}</p>
              </b-field>
            </div>
            <div class="column is-3">
              <b-field :label="$t('detailDispositif.infoGeneral.confrere')"
                      custom-class="has-text-link">
                <p class="has-text-default">
                  {{ dispositifPublicitaire.tiers ?
                    dispositifPublicitaire.tiers.nomCommercial : null }}
                </p>
              </b-field>
            </div>
            <div class="column is-3">
              <b-field :label="$t('detailDispositif.infoGeneral.appartenanceDispositif')"
                      custom-class="has-text-link">
                <p class="has-text-default">
                  {{ dispositifPublicitaire.proprietaire ? $t('general.oui') : $t('general.non') }}
                </p>
              </b-field>
            </div>
            <div class="column is-3">
              <b-field :label="$t('detailDispositif.infoGeneral.declarationPrealable')"
                      custom-class="has-text-link">
                <p class="has-text-default">
                  {{ dispositifPublicitaire.dispositifTechnique.declarationPrealable | formatDate }}
                </p>
              </b-field>
            </div>
            <div class="column is-3">
              <b-field :label="$t('detailDispositif.infoGeneral.restrictionsAffichage')"
                      custom-class="has-text-link">
                <p class="has-text-default">
                  {{ dispositifPublicitaire.dispositifTechnique.restrictionsAffichage }}
                </p>
              </b-field>
            </div>
            <div class="column is-3" v-if="moduleSecteurActive">
              <b-field :label="$t('detailDispositif.infoGeneral.secteur')"
                      custom-class="has-text-link">
                <p class="has-text-default">
                  {{ secteurLibelle }}
                </p>
              </b-field>
            </div>
            <div class="column is-3" v-if="moduleEmplacementClientActive
              && dispositifPublicitaire.emplacement.clientId !== null">
              <b-field :label="$t('detailDispositif.infoGeneral.tempsFort')"
                      custom-class="has-text-link">
                <p class="has-text-default">
                  {{ dispositifPublicitaire.tempFort ? $t('general.oui') : $t('general.non') }}
                </p>
              </b-field>
            </div>
          </div>
        </div>
      </div>
      <montage-demontage-consultation :dispositifPublicitaire="dispositifPublicitaire" id="montage">
      </montage-demontage-consultation>
      <div class="card mgt-30px" id="adresse" v-if="dispositifPublicitaire.adresse">
        <header class="header-card">
          <p>
            {{ $t('adresseEmplacement.adresse') }}
          </p>
        </header>
        <div class="card-content">
          <adresse-cadastrale :adresseCadastraleInformation="dispositifPublicitaire.adresse"
                              :showTitle="false">
          </adresse-cadastrale>
        </div>
      </div>
      <div class="card mgt-20px" id="divers">
        <header class="header-card">
          <p>
            {{ $t('detailDispositif.divers.title') }}
          </p>
        </header>
        <div class="card-content columns is-multiline">
          <div class="column is-3">
            <b-field :label="$t('detailDispositif.divers.pdlElectricite')"
                    custom-class="has-text-link">
              <p> {{ dispositifPublicitaire.pdlElectricite  }}</p>
            </b-field>
          </div>
          <div class="column is-3">
            <b-field :label="$t('detailDispositif.divers.iot')"
                    custom-class="has-text-link">
              <p> {{ dispositifPublicitaire.iot  }}</p>
            </b-field>
          </div>
        </div>
      </div>
      <div class="card mgt-30px" id="commentaire">
        <header class="header-card">
          <p>
            {{ $t('detailDispositif.infoGeneral.title.commentaire') }}
          </p>
        </header>
        <div class="card-content columns is-multiline">
          <div class="column is-12">
            <b-field :label="$t('detailDispositif.infoGeneral.commentaire')"
                      custom-class="has-text-link">
              <p class="has-text-default">
                {{ dispositifPublicitaire.commentaire }}
              </p>
            </b-field>
          </div>
        </div>
      </div>
      <div class="card mgt-30px" id="pj">
        <header class="header-card">
          <p>
            {{ $t('detailDispositif.infoGeneral.title.pj') }}
          </p>
        </header>
        <div class="card-content">
          <app-pieces-jointes :checkPermissions=checkPermissions(permEmplacement.maj)
                              readOnly
                              deletable
                              autoSave>
          </app-pieces-jointes>
        </div>
      </div>
    </div>
    <div class="column is-2">
      <div class="is-fixed mgt-20px">
        <dots-menu :steps="steps">
        </dots-menu>
        <information-create-update-user class="mgr-20px" :data="dispositifPublicitaire">
        </information-create-update-user>
      </div>
    </div>
  </div>
</template>
<script>
import { createNamespacedHelpers } from 'vuex';
import { EMPLACEMENT } from '@/configuration/gabed/permissionsGabedConf';
import PiecesJointes from '@/components/general/piecesJointes';
import adresseCadastrale from '@/components/gabed/emplacement/adresseConsultationEmplacement';
import Logo from '@/components/general/Logo';
import montageDemontageConsultation from '@/components/gabed/dispositif/c_montageDemontage';
import { PARAMETRES_INTERNE_KEYS, PARAMETRES_KEYS } from '@/store/modules/parametres-mutation-type';
import dotsMenu from '@/components/general/dotsMenu';
import InformationCreateUpdateUser from '@/components/general/informationCreateUpdateUser';

const permissions = createNamespacedHelpers('permissions');
const Parametres = createNamespacedHelpers('parametres');

export default {
  name: 'infoGenerale',
  props: {
    dispositifPublicitaire: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      permEmplacement: EMPLACEMENT,
      steps: [
        {
          name: this.$i18n.t('detailDispositif.steps.caracteristiques'),
          ref: '#caracteristiques',
          active: true,
        },
        {
          name: this.$i18n.t('detailDispositif.steps.montage'),
          ref: '#montage',
          active: false,
        },
        {
          name: this.$i18n.t('detailDispositif.steps.adresse'),
          ref: '#adresse',
          active: false,
        },
        {
          name: this.$i18n.t('detailDispositif.steps.divers'),
          ref: '#divers',
          active: false,
        },
        {
          name: this.$i18n.t('detailDispositif.steps.commentaire'),
          ref: '#commentaire',
          active: false,
        },
        {
          name: this.$i18n.t('detailDispositif.steps.pj'),
          ref: '#pj',
          active: false,
        },
      ],
    };
  },
  components: {
    appPiecesJointes: PiecesJointes,
    adresseCadastrale,
    appLogo: Logo,
    montageDemontageConsultation,
    dotsMenu,
    InformationCreateUpdateUser,
  },
  computed: {
    ...permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    ...Parametres.mapGetters({
      parametresInterne: 'parametresInterne',
      parametre: 'parametre',
    }),
    moduleEmplacementClientActive() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.moduleEmplacementClient.key);
    },
    moduleSecteurActive() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.moduleSecteur.key);
    },
    secteurs() {
      return this.parametre(PARAMETRES_KEYS.secteur);
    },
    secteurLibelle() {
      return this.secteurs
        .filter(s => {
          return this.dispositifPublicitaire.secteurs
            .map(lien => lien.secteurId)
            .includes(s.id);
        })
        .map(s => s.libelle)
        .join(', ');
    },
  },
  methods: {
    ...Parametres.mapActions({
      loadParametresInterne: 'loadParametresInterne',
      loadParametres: 'loadParametres',
    }),
  },
  async mounted() {
    await this.loadParametresInterne([PARAMETRES_INTERNE_KEYS.moduleSecteur.key]);
    if (this.moduleSecteurActive) {
      await this.loadParametres([PARAMETRES_KEYS.secteur]);
    }
  },
};
</script>
